import member from "./member.vue";
import memberDetail from "../member/memberDetail.vue";
import memberHistory from "../member/history.vue";
import notice from "./notice.vue";
import schedule from "./schedule.vue";
import version from "./version.vue";
import magazine from "./magazine.vue";
import wallet from "./wallet.vue";
import WalletApi from "@/api/admin/wallet";
import history from "./history.vue";
import confirm from "./confirm.vue";
import banner from "./banner.vue";
import healthBanner from "./healthBanner.vue";
import appPush from "./appPush.vue";

const routes: any[] = [
  {
    name: "root",
    path: "/",
    component: schedule,
  },
  {
    name: "member",
    path: "/member",
    component: member,
  },
  {
    name: "memberDetail",
    path: "/member/detail",
    component: memberDetail,
  },
  {
    name: "memberHistory",
    path: "/member/history",
    component: memberHistory,
  },
  {
    name: "notice",
    path: "/notice",
    component: notice,
  },
  {
    name: "schedule",
    path: "/schedule",
    component: schedule,
  },
  {
    name: "history",
    path: "/history",
    component: history,
  },
  {
    name: "version",
    path: "/version",
    component: version,
  },
  {
    name: "wallet",
    path: "/wallet",
    component: wallet,
  },
  {
    name: "magazine",
    path: "/magazine",
    component: magazine,
  },
  {
    name: "banner",
    path: "/banner",
    component: banner,
  },
  {
    name: "healthBanner",
    path: "/healthBanner",
    component: healthBanner,
  },
  {
    name: "confirm",
    path: "/confirm",
    component: confirm,
  },
  {
    name: "appPush",
    path: "/appPush",
    component: appPush,
  }
].map((item) => ({ layout: "home-layout", ...item }));

export default routes;
